import { render, staticRenderFns } from "./WaitlistFlag.vue?vue&type=template&id=7bc89ec8&scoped=true"
import script from "./WaitlistFlag.vue?vue&type=script&lang=js"
export * from "./WaitlistFlag.vue?vue&type=script&lang=js"
import style0 from "./WaitlistFlag.vue?vue&type=style&index=0&id=7bc89ec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc89ec8",
  null
  
)

export default component.exports